import { customElement } from 'aurelia-framework';
import { bindable } from 'aurelia-typed-observable-plugin';
import { ICountryUsersCountDTO } from 'api/swagger/ApiClient';

@customElement('users-locations-box')
export class UsersLocationsBoxCustomElement {
  @bindable
  data: ICountryUsersCountDTO[];
}
